import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CompanySubscriptionPlan } from '../../models/SubscriptionPlan';
import { RootState } from '../rootStore';

const initialValue: CompanySubscriptionPlan = {};

const CompanySubscriptionPlanSlice = createSlice({
  name: 'companySubscriptionPlan',
  initialState: initialValue,
  reducers: {
    setCompanySubscriptionPlanData: (
      state: CompanySubscriptionPlan,
      action: PayloadAction<CompanySubscriptionPlan>,
    ) => {
      return action.payload;
    },
  },
});

export const { setCompanySubscriptionPlanData } = CompanySubscriptionPlanSlice.actions;

export const selectCompanySubscriptionPlan = () => (rootState: RootState) =>
  rootState.companySubscriptionPlan;

export default CompanySubscriptionPlanSlice.reducer;
